module.exports = __webpack_public_path__ + "img/nope.f5703431.jpg";